import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UsersService } from '@app/@shared/services/api/users-account.service';
import { RedirectRouterService } from '@app/@shared/services/web/redirect-router.service';
import { ToastrService } from '@app/@shared/services/web/toastr.service';
import { Buffer } from 'buffer';
import { PropertiesService } from '@app/@shared/services/api/properties.service';

@Component({
  selector: 'app-manage-consents',
  templateUrl: './manage-consents.component.html',
  styleUrls: ['./manage-consents.component.scss'],
})
export class ManageConsentsComponent implements OnInit {
  loading: boolean = false;
  isLoadingEmail: boolean = false;
  allComplete: boolean = false;
  unsubscribe_all: boolean = false;
  consents: any[] = [
    // { name: 'components.list.unsubscribe.content', description:'', completed: false },
    // { name: 'components.list.unsubscribe.notifications', description:'', completed: false },
    // { name: 'components.list.unsubscribe.processes', description:'', completed: false },
    // { name: 'components.list.unsubscribe.commercial', description:'', completed: false },
  ];
  emailUser: string;
  action: string;
  verified: boolean = true;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private toastrService: ToastrService,
    private redirectService: RedirectRouterService,
    private service: PropertiesService,
    private readonly usersService: UsersService
  ) {}

  ngOnInit(): void {
    let { hash, action } = this.activatedRoute.snapshot.params;
    this.emailUser = Buffer.from(decodeURIComponent(hash), 'base64').toString(
      'ascii'
    );
    this.action = action;
    this.getConsents(hash);
  }

  getConsents(hash: string) {
    this.loading = true;
    this.usersService.getConsents(hash).subscribe({
      next: (value: any) => {
        this.consents = value.consents.map((c: any) => {
          return {
            ...c,
            completed: c.status === 'SUBSCRIBED',
          };
        });
      },
      error: (err) => {
        this.consents = [];
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  updateAllComplete() {
    this.allComplete =
      this.consents != null && this.consents.every((t) => t.completed);
  }

  someComplete(): boolean {
    if (this.consents == null) {
      return false;
    }
    return (
      this.consents.filter((t) => t.completed).length > 0 && !this.allComplete
    );
  }

  setAll(completed: boolean) {
    this.allComplete = completed;
    if (this.consents == null) {
      return;
    }
    this.consents.forEach((t) => {
      if (t.id !== '9444712') t.completed = completed;
    });
  }

  unsubscribe(unsubcribe: boolean = false) {
    const data = {
      email: this.emailUser,
      consents: this.consents,
    };
    if (unsubcribe) {
      data.consents = this.consents.map((c: any) => {
        return {
          ...c,
          completed: false,
        };
      });
    }
    this.loading = true;
    this.usersService.manageConsents(data).subscribe({
      next: (value: any) => {
      },
      error: (err) => {
        this.loading = false;
        if (err.error.type === 'no_verified') {
          this.verified = false;
        }
        this.toastrService.error(err.error.message, 'Atención');
      },
      complete: () => {
        this.loading = false;
        this.toastrService.success('Se han guardado los cambios', 'Éxito');
        this.redirectService.goToPage('/');
      },
    });
  }

  resendEmail() {
    this.loading = true;
    this.service.SendEmail({email: this.emailUser}).subscribe({
      next: (res) => {
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
      },
      complete: () => {
        this.toastrService.success('Se ha enviado el correo de verificación, revise su bandeja de entrada.', 'Éxito');
        this.redirectService.goToPage('/');
      }
    });
  }
}
